<h2 mat-dialog-title class="analytics-title">
    <mat-icon>analytics</mat-icon>
    Scan Analytics - {{data.product_title}}
</h2>

<mat-dialog-content class="analytics-content" *ngIf="!loading">
    <!-- Summary Cards -->
    <!-- <div class="summary-section">
        <div class="summary-card">
            <div class="card-icon" [style.background]="'#e3f2fd'">
                <mat-icon [style.color]="'#1976d2'">people</mat-icon>
            </div>
            <div class="card-content">
                <div class="card-value">{{summary.total_unique_users || 0}}</div>
                <div class="card-label">Unique Users</div>
            </div>
        </div>

        <div class="summary-card">
            <div class="card-icon" [style.background]="'#f3e5f5'">
                <mat-icon [style.color]="'#7b1fa2'">qr_code_2</mat-icon>
            </div>
            <div class="card-content">
                <div class="card-value">{{summary.total_unique_qrcodes || 0}}</div>
                <div class="card-label">QR Codes Scanned</div>
            </div>
        </div>

        <div class="summary-card">
            <div class="card-icon" [style.background]="'#e8f5e9'">
                <mat-icon [style.color]="'#388e3c'">touch_app</mat-icon>
            </div>
            <div class="card-content">
                <div class="card-value">{{summary.total_scans || 0}}</div>
                <div class="card-label">Total Scans</div>
            </div>
        </div>

        <div class="summary-card">
            <div class="card-icon" [style.background]="'#fce4ec'">
                <mat-icon [style.color]="'#c2185b'">check_circle</mat-icon>
            </div>
            <div class="card-content">
                <div class="card-value">{{summary.successful_scans || 0}}</div>
                <div class="card-label">Successful</div>
            </div>
        </div>
    </div> -->

    <!-- Tab Navigation -->
    <mat-tab-group class="analytics-tabs" (selectedIndexChange)="onTabChange($event)">

        <!-- Tab 1: All Scans -->
        <mat-tab label="All Scans" [disabled]="scanRecords.length === 0">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">timeline</mat-icon>
                <span class="tab-label">All Scans ({{scanRecords.length}})</span>
            </ng-template>

            <div class="tab-content">
                <mat-form-field class="filter-field" appearance="outline">
                    <mat-label>Filter</mat-label>
                    <input matInput placeholder="Search by name, phone, device..." (keyup)="applyFilter($event)">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>

                <div class="table-wrapper">
                    <table mat-table [dataSource]="scansDataSource" matSort class="scans-table">
                        <!-- Index Column -->
                        <ng-container matColumnDef="srNo">
                            <th mat-header-cell *matHeaderCellDef>Sr.No</th>
                            <td mat-cell *matCellDef="let element; let i = index">{{i + 1}}</td>
                        </ng-container>

                        <!-- Scan Date Column -->
                        <ng-container matColumnDef="scan_date">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Scan Date & Time</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="date-cell">
                                    <mat-icon class="date-icon">schedule</mat-icon>
                                    <span>{{formatDate(element.created_date)}}</span>
                                </div>
                            </td>
                        </ng-container>

                        <!-- User Name Column -->
                        <ng-container matColumnDef="user_name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>User</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="user-cell">
                                    <div class="user-avatar">{{(element.user_name || 'U').charAt(0).toUpperCase()}}
                                    </div>
                                    <div class="user-info">
                                        <div class="user-name">{{element.user_name || 'Unknown'}}</div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- User Mobile Column -->
                        <ng-container matColumnDef="user_mobile">
                            <th mat-header-cell *matHeaderCellDef>Mobile</th>
                            <td mat-cell *matCellDef="let element">
                                <a href="tel:{{element.user_mobile}}" class="mobile-link" *ngIf="element.user_mobile">
                                    {{element.user_mobile}}
                                </a>
                                <span *ngIf="!element.user_mobile">-</span>
                            </td>
                        </ng-container>

                        <!-- Device Type Column -->
                        <ng-container matColumnDef="device_type">
                            <th mat-header-cell *matHeaderCellDef>Device</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="device-badge" [class]="'device-' + element.device_type.toLowerCase()">
                                    <mat-icon class="device-icon">{{getDeviceIcon(element.device_type)}}</mat-icon>
                                    <span>{{element.device_type}}</span>
                                </div>
                            </td>
                        </ng-container>

                        <!-- OS Column -->
                        <ng-container matColumnDef="os">
                            <th mat-header-cell *matHeaderCellDef>Operating System</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="os-tag">{{element.os || '-'}}</span>
                            </td>
                        </ng-container>

                        <!-- Browser Column -->
                        <!-- <ng-container matColumnDef="browser">
                            <th mat-header-cell *matHeaderCellDef>Browser</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="browser-tag">{{element.browser || '-'}}</span>
                            </td>
                        </ng-container> -->

                        <!-- Device Name Column -->
                        <ng-container matColumnDef="device_name">
                            <th mat-header-cell *matHeaderCellDef>Device Model</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="device-model">{{element.device_name || '-'}}</span>
                            </td>
                        </ng-container>

                        <!-- Status Column -->
                        <!-- <ng-container matColumnDef="result_status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="status-badge" [class]="'status-' + element.result_status.toLowerCase()">
                                    <mat-icon>{{element.result_status === 'success' ? 'check_circle' :
                                        'cancel'}}</mat-icon>
                                    {{element.result_status | uppercase}}
                                </span>
                            </td>
                        </ng-container> -->

                        <tr mat-header-row *matHeaderRowDef="scansDisplayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: scansDisplayedColumns;"></tr>
                    </table>
                </div>

                <mat-paginator #scansPaginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons
                    aria-label="Select page of scans">
                </mat-paginator>
            </div>
        </mat-tab>

        <!-- Tab 2: Users Summary -->
        <mat-tab label="Users" [disabled]="userScans.length === 0">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">people</mat-icon>
                <span class="tab-label">Users ({{userScans.length}})</span>
            </ng-template>

            <div class="tab-content">
                <mat-form-field class="filter-field" appearance="outline">
                    <mat-label>Filter</mat-label>
                    <input matInput placeholder="Search by name, phone..." (keyup)="applyFilter($event)">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>

                <div class="table-wrapper">
                    <table mat-table [dataSource]="usersDataSource" matSort class="users-table">
                        <!-- Index Column -->
                        <ng-container matColumnDef="srNo">
                            <th mat-header-cell *matHeaderCellDef>Sr.No</th>
                            <td mat-cell *matCellDef="let element; let i = index">{{i + 1}}</td>
                        </ng-container>

                        <!-- User Name Column -->
                        <ng-container matColumnDef="user_name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="user-cell">
                                    <div class="user-avatar">{{(element.user_name || 'U').charAt(0).toUpperCase()}}
                                    </div>
                                    <div class="user-info">
                                        <div class="user-name">{{element.user_name || 'Unknown'}}</div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- User Mobile Column -->
                        <ng-container matColumnDef="user_mobile">
                            <th mat-header-cell *matHeaderCellDef>Mobile</th>
                            <td mat-cell *matCellDef="let element">
                                <a href="tel:{{element.user_mobile}}" class="mobile-link" *ngIf="element.user_mobile">
                                    {{element.user_mobile}}
                                </a>
                                <span *ngIf="!element.user_mobile">-</span>
                            </td>
                        </ng-container>

                        <!-- Scan Count Column -->
                        <ng-container matColumnDef="user_scan_count">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Scans</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="scan-count-badge" [class.high]="element.user_scan_count > 5">
                                    {{element.user_scan_count}}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Unique QR Codes Column -->
                        <ng-container matColumnDef="unique_qrcodes_scanned">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Unique QR Codes</th>
                            <td mat-cell *matCellDef="let element">
                                <span class="qr-count-badge">
                                    {{element.unique_qrcodes_scanned}}
                                </span>
                            </td>
                        </ng-container>

                        <!-- First Scan Column -->
                        <ng-container matColumnDef="first_scan">
                            <th mat-header-cell *matHeaderCellDef>First Scan</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="date-cell">
                                    <mat-icon class="date-icon">schedule</mat-icon>
                                    <span>{{formatDate(element.first_scan)}}</span>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Last Scan Column -->
                        <ng-container matColumnDef="last_scan">
                            <th mat-header-cell *matHeaderCellDef>Last Scan</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="date-cell">
                                    <mat-icon class="date-icon">schedule</mat-icon>
                                    <span>{{formatDate(element.last_scan)}}</span>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="usersDisplayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: usersDisplayedColumns;"></tr>
                    </table>
                </div>

                <mat-paginator #usersPaginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons
                    aria-label="Select page of users">
                </mat-paginator>
            </div>
        </mat-tab>

        <!-- Tab 3: Statistics -->
        <mat-tab label="Statistics">
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">bar_chart</mat-icon>
                <span class="tab-label">Statistics</span>
            </ng-template>

            <div class="tab-content statistics-content">
                <div class="stats-grid">
                    <div class="stat-card">
                        <div class="stat-header">Success Rate</div>
                        <div class="stat-value">
                            {{summary.successful_scans && summary.total_scans ?
                            ((summary.successful_scans / summary.total_scans) * 100 | number:'1.1-1') : 0}}%
                        </div>
                        <div class="stat-bar">
                            <div class="stat-fill" [style.width.%]="summary.successful_scans && summary.total_scans ? 
                ((summary.successful_scans / summary.total_scans) * 100) : 0"></div>
                        </div>
                    </div>

                    <div class="stat-card">
                        <div class="stat-header">Failed Scans</div>
                        <div class="stat-value">{{summary.failed_scans || 0}}</div>
                        <div class="stat-description">Out of {{summary.total_scans || 0}} total</div>
                    </div>

                    <div class="stat-card">
                        <div class="stat-header">Avg Scans Per User</div>
                        <div class="stat-value">
                            {{summary.total_unique_users && summary.total_scans ?
                            (summary.total_scans / summary.total_unique_users | number:'1.1-1') : 0}}
                        </div>
                        <div class="stat-description">Average scans per person</div>
                    </div>

                    <div class="stat-card">
                        <div class="stat-header">Last Scan</div>
                        <div class="stat-value">{{formatDate(summary.last_scan_time)}}</div>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>

<mat-dialog-content class="analytics-content" *ngIf="loading">
    <div class="loading-container">
        <mat-spinner></mat-spinner>
        <p>Loading scan analytics...</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="analytics-actions">
    <button mat-stroked-button (click)="downloadScanData()" [disabled]="loading">
        <mat-icon>download</mat-icon>
        Export CSV
    </button>
    <button mat-button mat-dialog-close [disabled]="loading">Close</button>
</mat-dialog-actions>